// extracted by mini-css-extract-plugin
export default {"componentWrapper":"MessageSettings_componentWrapper__fMimH","notifications":"MessageSettings_notifications__lOjZ5","notification":"MessageSettings_notification__1PJUU"};